/** Utility to watch for clicks outside of specified elements and fire callbacks */
export class OutsideClickWatcher {
    static clickOutsideListeners = [];
    static lastListenerId = 0;
    static isInitialized = false;

    /** Called internally if a listener is added but no global listener is created yet */
    static Initialize() {
        this.isInitialized = true;
        // On every click, check if anyone's listening for outside clicks
        window.addEventListener("click", e => {
            for (const listener of this.clickOutsideListeners) {
                // If the click is outside the listener's element, fire the callback
                if (!listener[0].contains(e.target)) {
                    listener[1].call();
                }
            }
        });
    }

    /**
     * Listen for clicks outside an element
     * @param {HTMLElement} insideElement Any clicks inside this element will be ignored
     * @param {Function} callback Will be run when a click outside is detected
     * @returns A numeric ID that can be used later to remove the listener
     */
    static AddListener(insideElement, callback) {
        if (!this.isInitialized) this.Initialize();
        this.lastListenerId += 1;
        this.clickOutsideListeners.push([insideElement, callback, this.lastListenerId]);
        // Return an id we can use for later removal
        return this.lastListenerId;
    }

    /**
     * Remove an existing click-outside listener
     * @param {Number} id ID of the listener we received at creation time
     */
    static RemoveListener(id) {
        const index = this.clickOutsideListeners.findIndex(l => l[2] === id);
        if (index >= 0) {
            this.clickOutsideListeners.splice(index, 1);
        }
    }
}
